export default __webpack_public_path__ + "static/media/Alice_Evening.4b16be68.wav";